import _extends from 'babel-runtime/helpers/extends';

export default {
  name: 'TagCascaderMulti',

  componentName: 'TagCascaderMulti',

  props: {
    config: {
      type: Object,
      required: true
    },
    formValue: {
      type: Object,
      required: true
    }
  },

  data: function data() {
    return {
      resTags: [],
      cascaderProps: {
        multiple: true,
        emitPath: false
      }
    };
  },


  computed: {
    innerConfig: function innerConfig() {
      var params = _extends({
        clearable: true,
        placeholder: '' + this.$t('playTurbo.custom.resourceUploader.tagPlaceholder'),
        size: 'medium',
        'show-all-levels': false
      }, this.config.params);
      params.data = this.resTags;
      return _extends({}, this.config, {
        params: params
      });
    }
  },

  mounted: function mounted() {
    if (this.resTags && !this.resTags.length) {
      this.getTags();
    }
  },


  methods: {
    getTags: function getTags() {
      var _this = this;

      var params = this.innerConfig.params ? this.innerConfig.params.params : {};
      if (this.$store.state.tags.resourceTagList[params.type]) {
        this.resTags = this.$store.state.tags.resourceTagList[params.type];
      } else {
        this.$store.dispatch('GetResTagList', { params: params }).then(function (tagList) {
          _this.resTags = tagList;
        }).catch(function (error) {
          _this.$message.error(error.message);
        });
      }
    }
  },

  watch: {
    'config': function config(val) {
      // 配置变化，重新请求接口
      this.getTags();
    }
  }
};